import React from "react";
import { useTifList } from "../../../data/initialData/hooks/useTifList";
import { TifList } from "../../../data/models";
import { AutocompleteSelect, AutocompleteSelectType,} from "./AutocompleteSelect";

type RegionSelectPropsType = Omit<
  AutocompleteSelectType<TifList>,
  "data" | "getLabel"
>;

// verzija pre izbacivanja Do opoziva
{/*export const TifListSelect: React.FunctionComponent<RegionSelectPropsType> = (
  props
) => {
  const [statuses, renderStatus] = useTifList();

  return (
    <AutocompleteSelect<TifList>
      data={statuses}
      getLabel={renderStatus}
      {...(props as any)}
    />
  );
};  */}


export const TifListSelect: React.FC<  RegionSelectPropsType & { filter?: (item: TifList) => boolean }
> = ({ filter, ...rest }) => {
  const [statuses, renderStatus] = useTifList();

  const filtered = filter ? statuses.filter(filter) : statuses;

  // ⛔ rest može sadržati variant="standard" ili variant="filled"
  // zato ga moramo IZBACITI
  const { variant, ...restWithoutVariant } = rest as any;

  return (
    <AutocompleteSelect<TifList>
      data={filtered}
      getLabel={renderStatus}
      {...restWithoutVariant}   // ✔ sada više ne može da ubaci pogrešnu varijantu
    />
  );
};
